import { render } from "./GlobalScripts.vue?vue&type=template&id=81a8775c"
import script from "./GlobalScripts.vue?vue&type=script&lang=js"
export * from "./GlobalScripts.vue?vue&type=script&lang=js"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__